'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _toConsumableArray = require('@babel/runtime-corejs3/helpers/toConsumableArray');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var lodash = require('lodash');
var dbLoadingJobLogic = require('./db-loading-job-logic.js');
var gsqlLoadingJobLogic_model = require('./gsql-loading-job-logic.model.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);

/**
 * Check data mapping change, whether there is no change, style change only
 * or data mapping is changed.
 *
 * @enum {number}
 */
var LoadingJobChangeStatus = /*#__PURE__*/function (LoadingJobChangeStatus) {
  LoadingJobChangeStatus[LoadingJobChangeStatus["NoChange"] = 0] = "NoChange";
  LoadingJobChangeStatus[LoadingJobChangeStatus["StyleChange"] = 1] = "StyleChange";
  LoadingJobChangeStatus[LoadingJobChangeStatus["DataMappingChange"] = 2] = "DataMappingChange";
  return LoadingJobChangeStatus;
}({});
var LoadingJobChangeLogic = /*#__PURE__*/function () {
  function LoadingJobChangeLogic() {
    _classCallCheck__default["default"](this, LoadingJobChangeLogic);
  }
  return _createClass__default["default"](LoadingJobChangeLogic, null, [{
    key: "getLoadingJobChange",
    value:
    /**
     * Get the loading job change.
     *
     * @static
     * @param {GSQLLoadingJobJson[]} savedLoadingJobs
     * @param {GSQLLoadingJobJson[]} inMemoryGSQLLoadingJobs
     * @param {DBLoadingJobJson[]} savedLoadingJobsStyle
     * @param {DBLoadingJobJson[]} inMemoryLoadingJobsStyle
     * @param {DBGraphStyleJson} savedGraphStyle
     * @param {DBGraphStyleJson} inMemoryGraphStyle
     * @returns {LoadingJobChange}
     * @memberof LoadingJobChangeLogic
     */
    function getLoadingJobChange(savedLoadingJobs, inMemoryGSQLLoadingJobs, savedLoadingJobsStyle, inMemoryLoadingJobsStyle, savedGraphStyle, inMemoryGraphStyle) {
      // FIXME: GSQL need change export format of WHERE clause same as it receives.
      var savedGSQLLoadingJobs = gsqlLoadingJobLogic_model.GSQLLoadingJobLogic.handleWhereClause(savedLoadingJobs);
      inMemoryGSQLLoadingJobs = gsqlLoadingJobLogic_model.GSQLLoadingJobLogic.handleWhereClause(inMemoryGSQLLoadingJobs);
      var status = LoadingJobChangeStatus.NoChange;
      var jobNames = [];
      if (!lodash.isEqual(savedGraphStyle, inMemoryGraphStyle)) {
        status = LoadingJobChangeStatus.StyleChange;
      }
      if (!lodash.isEqual(savedLoadingJobsStyle, inMemoryLoadingJobsStyle)) {
        jobNames.push.apply(jobNames, _toConsumableArray__default["default"](dbLoadingJobLogic.LoadingJobStyleLogic.getUnsavedLoadingJobStyleNames(savedLoadingJobsStyle, inMemoryLoadingJobsStyle)));
        status = LoadingJobChangeStatus.StyleChange;
      }
      if (!lodash.isEqual(savedGSQLLoadingJobs, inMemoryGSQLLoadingJobs)) {
        jobNames.push.apply(jobNames, _toConsumableArray__default["default"](gsqlLoadingJobLogic_model.GSQLLoadingJobLogic.getUnsavedGSQLLoadingJobNames(savedGSQLLoadingJobs, inMemoryGSQLLoadingJobs)));
        status = LoadingJobChangeStatus.DataMappingChange;
      }
      return {
        status: status,
        jobNames: jobNames
      };
    }
  }]);
}();

exports.LoadingJobChangeLogic = LoadingJobChangeLogic;
exports.LoadingJobChangeStatus = LoadingJobChangeStatus;
